import { useSelector } from 'react-redux';

import HomeRedirect from 'app/components/HomeRedirect';

const Admin = props => {
  const {
    children
  } = props;

  const user = useSelector(state => state.userReducer.user);

  if (!user.has_wheel) {
    console.log("HomeRedirect");
    return <HomeRedirect />;
  }

  return <div>{children}</div>;
}

export default Admin;
